import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IHomeState } from 'src/app/features/home/state/home.model';

@Component({
  selector: 'app-marketing-pillars',
  templateUrl: './marketing-pillars.component.html',
  styleUrls: ['./marketing-pillars.component.scss']
})
export class MarketingPillarsComponent implements OnInit {
  @Input() announcements: IHomeState['announcements'];
  @Input() mpCardsContent: IHomeState['mpCards'];
  constructor(private router:Router) {}

  ngOnInit() {}

  navigateTo(path:string){
    this.router.navigate([`/${path}`]);
  }
}
